<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="18">
                <div class="spreadsheet-header-title">
                    {{ title }}
                </div>
                <div class="spreadsheet-header-filter-info">
                    <span class="spreadsheet-header-filter-info_black">
                        Поиск по:
                    </span>
                    <span class="spreadsheet-header-filter-info_gray">
                        {{ filterTitle }}
                    </span>
                </div>
            </el-col>
            <el-col :span="2">
                <el-popover
                    popper-class="grid-search-dialog"
                    placement="top"
                    width="293"
                    trigger="click"
                    v-model="isFilterFormVisible"
                >
                    <el-button slot="reference" class="spreadsheet-header-button" type="warning">
                        поиск
                    </el-button>
                    <el-form label-position="top">
                        <el-form-item :label="fieldsNames.office_id" :label-width="formLabelWidth">
                            <el-select
                                v-model="filterModel.office_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                multiple
                                collapse-tags
                                clearable
                                autocomplete
                                :placeholder="fieldsNames.office_id"
                                size="mini"
                            >
                                <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.pay_type_id" :label-width="formLabelWidth">
                            <el-select
                                v-model="filterModel.pay_type_category_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                multiple
                                collapse-tags
                                clearable
                                autocomplete
                                :placeholder="fieldsNames.pay_type_id"
                                size="mini"
                            >
                                <el-option v-for="item in payTypeCategoriesList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="popover-footer">
                        <el-button @click="hideFilterForm">
                            Отменить
                        </el-button>
                        <el-button type="warning" @click="filterApplied">
                            Применить
                        </el-button>
                    </div>
                </el-popover>
            </el-col>
            <el-col :span="3">
                <span class="spreadsheet-header-total">
                    {{ total }}: {{ allCashBalance }} руб.
                </span>
            </el-col>
            <el-col :span="1" title="Excel" class="icon-excel" v-if="isExcelButtonVisible">
                <div class="spreadsheet-header-excel">
                    &nbsp;
                </div>
            </el-col>
        </el-row>
        <el-row v-loading="loading">
            <el-col :span="12" class="cash-main">
                <div class="cash-all-balance">
                    Итого: {{ allCashBalance }} руб.
                </div>
                <div class="cash-total-by-paytype">
                    <template v-for="(raw, index) in cashTotal">
                        <div :key="index">
                            {{ raw.name }}: {{ formatFinance(raw.sum) }} руб.
                        </div>
                    </template>
                </div>
                <el-tree :data="cash" :props="cashTreeProps" />
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import '@/assets/styles/list.scss';
import '@/assets/styles/cash.scss';
import { formatFinance, getNames, declOfNum } from '@/common/utilities';

export default {
    name: 'CashList',
    data() {
        return {
            title: 'Кассы',
            loading: true,
            isFilterFormVisible: false,
            formLabelWidth: '120px',
            filterModel: {
                office_id: [],
                category_id: []
            },
            fieldsNames: {
                office_id: 'Офис',
                category_id: 'Вид оплаты'
            },
            cashTreeProps: {
                children: 'children',
                label: 'label'
            }
        };
    },
    computed: {
        cash() {
            const rawData = this.$store.state.cash.cash;
            const officeIds = [...new Set(rawData.map(item => item.office_id))];
            const result = [];
            officeIds.forEach(id => {
                const cashes = rawData.filter(item => item.office_id === id);
                const officeBalance = cashes.reduce((sum, curr) => sum + +curr.balance, 0);
                const office = {
                    label: `${cashes[0].office_name.toLocaleUpperCase()}: ${formatFinance(officeBalance)}  руб.`,
                    children: []
                };
                cashes.forEach(cash => {
                    office.children.push({
                        label: `${cash.pay_type_category_name.toLocaleUpperCase()}: ${formatFinance(cash.balance)} руб.`
                    });
                });
                result.push(office);
            });
            return result;
        },
        cashTotal() {
            const rawData = this.$store.state.cash.cash;
            const payTypeIds = [...new Set(rawData.map(item => item.pay_type_category_id))];
            const result = [];
            payTypeIds.forEach(id => {
                const cashes = rawData.filter(item => item.pay_type_category_id === id);
                const payTypeBalance = cashes.reduce((sum, curr) => sum + +curr.balance, 0);
                result.push({ name: cashes[0].pay_type_category_name.toLocaleUpperCase(), sum: payTypeBalance });
            });
            return result;
        },
        total() {
            const totalCashes = this.$store.state.cash.cash.length;
            const cashesTitles = ['касса', 'кассы', 'касс'];
            return declOfNum(totalCashes, cashesTitles);
        },
        allCashBalance() {
            return this.$store.state.cash.allCashBalance;
        },
        officeList() {
            return this.$store.state.references.offices || [];
        },
        payTypeCategoriesList() {
            return this.$store.state.references.payTypesCategories || [];
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field] && this.filterModel[field].length) {
                    switch (field) {
                        case 'pay_type_category_id':
                            result += getNames(this.payTypeCategoriesList, field, this.fieldsNames, this.filterModel);
                            break;
                        case 'office_id':
                            result += getNames(this.officeList, field, this.fieldsNames, this.filterModel);
                            break;
                    }
                }
            }
            return result;
        },
        isExcelButtonVisible() {
            //использовать в задаче реализации экспорта в excel
            return false;
        }
    },
    mounted() {
        this.$store.dispatch('preferences/getPreferences')
            .then(() => { this.setSettings(); })
            .finally(() => { this.getDataFromServer(); });
    },
    methods: {
        formatFinance,
        async getDataFromServer() {
            const requestParams = {
                filter: this.filterModel
            };
            this.loading = true;
            await this.$store.dispatch('cash/getList', requestParams);
            this.saveSetting();
            this.loading = false;
        },
        setSettings() {
            const settings = this.setting.cash;
            if (settings) {
                this.filterModel = JSON.parse(JSON.stringify(settings.filter));
            }
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.getDataFromServer();
        },
        async saveSetting() {
            const data = {
                'cash': {
                    'filter': this.filterModel
                }
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        }
    }
};
</script>
